import assign from 'lodash/assign';
import some from 'lodash/some';

// Constellation
import { ButtonGroup, ToggleButton } from '@zillow/constellation';

// Components
import FilterWrapper from '../FilterWrapper';

// Redux
import { useAppSelector } from '../../flux/configureStore';

// Misc / Utils
import { defaultValues } from '../../models/Filter';
import { useOptimisticReducer } from '../../utils/hooks';
import * as S from './styles';

// Types
import type { PartialFilterType } from '../../models/Types';

const Beds = ({ onFilterChange }: { onFilterChange: (arg0: PartialFilterType) => void }) => {
  const bedroomFilterRedux = useAppSelector((state) => state.filter.bedrooms);
  const [bedroomFilter, setBedroomFilter] = useOptimisticReducer(bedroomFilterRedux);
  const hasBedroomFilterSet = some(Object.values(bedroomFilter), (val: boolean) => !val);

  const handleFilterClick = (bedroom: string) => {
    let newBedroomFilter = assign({}, bedroomFilter);

    if (hasBedroomFilterSet) {
      // check if current selection is only selection
      const otherBedroomFiltersSet = Object.entries(bedroomFilter).filter((entry) => entry[0] !== bedroom && entry[1]);

      if (bedroom === 'any') {
        newBedroomFilter = defaultValues.bedrooms;
      } else if (!otherBedroomFiltersSet.length) {
        // current selection is only bed set
        newBedroomFilter = defaultValues.bedrooms;
      } else if (otherBedroomFiltersSet.length === 4) {
        // current selection is only bed *not* currently set
        newBedroomFilter = defaultValues.bedrooms;
      } else {
        newBedroomFilter[bedroom] = !bedroomFilter[bedroom];
      }
    } else {
      if (bedroom === 'any') {
        return false;
      } else {
        const otherBedroomFilters = Object.entries(bedroomFilter).filter((entry) => entry[0] !== bedroom);
        otherBedroomFilters.forEach((entry) => {
          newBedroomFilter[entry[0]] = false;
        });
      }
    }

    setBedroomFilter({ type: 'ALL', payload: newBedroomFilter });
    onFilterChange({ bedrooms: newBedroomFilter });
  };

  const component = (
    <S.Container>
      {/* @ts-expect-error */}
      <ButtonGroup conjoined onChange={handleFilterClick}>
        <ToggleButton pressed={!hasBedroomFilterSet} onClick={() => handleFilterClick('any')}>
          Any
        </ToggleButton>
        <ToggleButton pressed={hasBedroomFilterSet && bedroomFilter[0]} onClick={() => handleFilterClick('0')}>
          S
        </ToggleButton>
        <ToggleButton pressed={hasBedroomFilterSet && bedroomFilter[1]} onClick={() => handleFilterClick('1')}>
          1
        </ToggleButton>
        <ToggleButton pressed={hasBedroomFilterSet && bedroomFilter[2]} onClick={() => handleFilterClick('2')}>
          2
        </ToggleButton>
        <ToggleButton pressed={hasBedroomFilterSet && bedroomFilter[3]} onClick={() => handleFilterClick('3')}>
          3
        </ToggleButton>
        <ToggleButton
          pressed={hasBedroomFilterSet && bedroomFilter['4plus']}
          onClick={() => handleFilterClick('4plus')}
        >
          4+
        </ToggleButton>
      </ButtonGroup>
    </S.Container>
  );

  return FilterWrapper({
    heading: 'Bedrooms',
    children: component,
  });
};

export default Beds;
